import { Status } from "../../interfaces/approve_workflow/workflow-history";
import { Grupo } from "../groups/grupo.type";
import { ModelBase } from "../shared/model.base";
import { ShortCode } from "../shared/shortcode.type";

export class SMSTemplate extends ModelBase {
    constructor(
        public id: number = null,
        public name: string = null,
        public content: string = null,
        public status: Status = null,
        public groups: Grupo[] = null,
        public shortCode: ShortCode = null,
        public url_code: string = null,
        public service_type: string = null
    ) {
        super();
    }
}
